import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { OpenAppButton } from "../components/landing/OpenAppButton";
import { LANDING_PATH } from "../lib/app-paths";

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="pp-not-found">
      <div>
        <h1>{t("landing.notFoundTitle")}</h1>
        <p>{t("landing.notFoundBody")}</p>
      </div>
      <div className="pp-not-found-actions">
        <OpenAppButton size="lg" label={t("landing.openAppShort")} />
        <Link
          to={LANDING_PATH}
          className="pp-open-app pp-open-app--lg pp-open-app--ghost"
        >
          {t("landing.goToSite")}
        </Link>
      </div>
    </div>
  );
};
